export default "__VITE_ASSET__BKzWqCA3__"